import { tokenName } from './theme.js'
import { tooltipStyle } from './model.js'

// ChartTooltip 은 한 시각의 값을 한 번에 보여주는 팝오버다.
//
// 레인 여럿을 세로로 쌓는 화면에서 레인마다 따로 띄우지 않고 **하나로 모아** 띄우는 것이
// 기본이다 — 셋이 따로 뜨면 사람이 세 번 올려 보고 머리로 합쳐야 한다. 그래서 차트 판이
// 아니라 레인들을 감싼 상자에 한 번 둔다(README 「레인 여럿」).
//
//   ratio   가리킨 시각이 판 가로의 어디쯤인가(0~1). 오른쪽 절반이면 왼쪽으로 뒤집는다
//   offset  판이 상자 왼쪽에서 얼마나 떨어져 있나(px) — 보통 TimeChart 의 yAxisSize
//   time    머리에 적을 시각 글자
//   rows    [{ key, label, color, value, focus?, dim? }] — 값이 없는 줄도 지우지 말고 '—' 로 넘겨라.
//           줄이 사라지면 팝오버 높이가 움직이고 「그 시각에 그 축이 비었다」가 안 보인다.
//           focus 는 사람이 지금 올린 레인의 줄(크고 굵게), dim 은 나머지(흐리게)다. 줄이 열 개쯤 되면
//           같은 무게로는 「내가 보는 값」을 못 찾는다. 차례는 부르는 쪽이 정한다(보통 focus 를 맨 위로)
//   steady  true 면 focus 줄을 **크기 그대로** 굵게 + 옅은 띠로만 강조한다. 줄 차례를 고정해 두고
//           제자리에서 강조하는 화면(store-mops 리소스 추이)용이다 — focus 줄만 글자가 커지면 올린
//           레인이 바뀔 때마다 그 줄 높이가 달라져 팝업이 출렁인다
//
// 세로 자리는 고정이고 가로만 기준선을 따라간다. 마우스를 위아래로 따라다니면 읽기 어렵다.
export default function ChartTooltip({ ratio, offset = 0, time, rows, steady = false }) {
  if (ratio == null) return null
  const { flip, style } = tooltipStyle(ratio, offset)
  return (
    <div className={`mops-chart-tip${flip ? ' is-flip' : ''}${steady ? ' is-steady' : ''}`} role="status" style={style}>
      <div className="mops-chart-tip__time">{time}</div>
      {rows.map((r) => (
        <div key={r.key ?? r.label}
          className={`mops-chart-tip__row${r.focus ? ' is-focus' : ''}${r.dim ? ' is-dim' : ''}`}>
          <i className="mops-chart-tip__swatch" style={{ '--swatch': `var(${tokenName(r.color)})` }} />
          <span className="mops-chart-tip__label">{r.label}</span>
          <span className="mops-chart-tip__value">{r.value}</span>
        </div>
      ))}
    </div>
  )
}
